/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UmbrellaFreelancerHandledRequestResource } from './';
import {
    UmbrellaFreelancerHandledRequestResourceFromJSON,
    UmbrellaFreelancerHandledRequestResourceFromJSONTyped,
    UmbrellaFreelancerHandledRequestResourceToJSON,
} from './';
import type { UmbrellaFreelancerPendingRequestResource } from './';
import {
    UmbrellaFreelancerPendingRequestResourceFromJSON,
    UmbrellaFreelancerPendingRequestResourceFromJSONTyped,
    UmbrellaFreelancerPendingRequestResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface UmbrellaFreelancerRequestResources
 */
export interface UmbrellaFreelancerRequestResources {
    /**
     * 
     * @type {Array<UmbrellaFreelancerPendingRequestResource>}
     * @memberof UmbrellaFreelancerRequestResources
     */
    pendingRequest: Array<UmbrellaFreelancerPendingRequestResource>;
    /**
     * 
     * @type {Array<UmbrellaFreelancerHandledRequestResource>}
     * @memberof UmbrellaFreelancerRequestResources
     */
    handledRequest: Array<UmbrellaFreelancerHandledRequestResource>;
}

/**
 * Check if a given object implements the UmbrellaFreelancerRequestResources interface.
 */
export function instanceOfUmbrellaFreelancerRequestResources(value: object): value is UmbrellaFreelancerRequestResources {
    if (!('pendingRequest' in value) || value['pendingRequest'] === undefined) return false;
    if (!('handledRequest' in value) || value['handledRequest'] === undefined) return false;
    return true;
}

export function UmbrellaFreelancerRequestResourcesFromJSON(json: any): UmbrellaFreelancerRequestResources {
    return UmbrellaFreelancerRequestResourcesFromJSONTyped(json, false);
}

export function UmbrellaFreelancerRequestResourcesFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmbrellaFreelancerRequestResources {
    if (json == null) {
        return json;
    }
    return {
        
        'pendingRequest': ((json['pendingRequest'] as Array<any>).map(UmbrellaFreelancerPendingRequestResourceFromJSON)),
        'handledRequest': ((json['handledRequest'] as Array<any>).map(UmbrellaFreelancerHandledRequestResourceFromJSON)),
    };
}

export function UmbrellaFreelancerRequestResourcesToJSON(value?: UmbrellaFreelancerRequestResources | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'pendingRequest': ((value['pendingRequest'] as Array<any>).map((v) => UmbrellaFreelancerPendingRequestResourceToJSON(v))),
        'handledRequest': ((value['handledRequest'] as Array<any>).map((v) => UmbrellaFreelancerHandledRequestResourceToJSON(v))),
    };
}

